import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addConversation } from '@rsos/reduxDataStore/src/features/conversations/conversationsSlice';
import { addLocToQueue } from '../../../actions';
import useHasAccessToAdminLineRequests from '../../../hooks/useHasAccessToAdminLineRequests';

const CONVERSATION_START = 'conversation.start';

const useHandleConversationMessage = () => {
  const StreamWS = window?.__RSOS?.streamWS?.instance;
  const dispatch = useDispatch();
  const hasAdminLineRequests = useHasAccessToAdminLineRequests();

  const handleConversationMessage = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (message: any) => {
      if (message?.type === CONVERSATION_START && hasAdminLineRequests) {
        dispatch(addLocToQueue(message?.body));
        dispatch(addConversation(message?.body));
      }
    },
    [dispatch, hasAdminLineRequests],
  );

  useEffect(() => {
    if (StreamWS) {
      StreamWS.addOnMessageCallback({
        handleConversationMessage: handleConversationMessage,
      });

      return () => {
        StreamWS.removeOnMessageCallback('handleConversationMessage');
      };
    }
  }, [StreamWS, handleConversationMessage]);
};

export default useHandleConversationMessage;
